// extracted by mini-css-extract-plugin
module.exports = {"root":"📦Thumbnail__root--5HHWM","img":"📦Thumbnail__img--1AQ5w","error":"📦Thumbnail__error--3SSFN","center":"📦Thumbnail__center--3QXmT"};